import script from "./ReviewModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ReviewModal.vue?vue&type=script&setup=true&lang=js"

import "./ReviewModal.vue?vue&type=style&index=0&id=ff9441b2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff9441b2"]])

export default __exports__